export default __webpack_public_path__ + "static/rpa-shipping-automation-fd12771f2dda15d5f51b0003050abf43.png";